<div class="buttons-container">
    <button class="cancel button" (click)="cancelClick()">
        {{ 'dlg.cancel' | translate }}
    </button>
    <app-button
        [disable]="!hasDifferences"
        text="dlg.save"
        customFontFamily="NotoSans-SemiBold"
        size="small"
        customFontSize="14px"
        (onClick)="saveChanges()"></app-button>
</div>

<div class="container">
    <div class="header">
        <div class="title">
            {{ 'ops-setting.tab.external-comm-settings' | translate }}
        </div>
        <app-button (onClick)="openProtocolList()" text="ext-comm-settings.manage-protocols"></app-button>
    </div>

    <ng-container *ngIf="commsList?.length > 1">
        <app-dropdown-accordion
            class="comm-accordion"
            *ngFor="let fcuUnit of commsList"
            [header]="getFcuHeader(fcuUnit)"
            [isPortsTable]="true"
            [isInitialOpen]="false">
            <ng-container *ngTemplateOutlet="commTemplate; context: { fcuUnit }" />
        </app-dropdown-accordion>
    </ng-container>

    <ng-container *ngIf="commsList?.length == 1">
        <ng-container *ngTemplateOutlet="commTemplate; context: { fcuUnit: commsList[0] }" />
    </ng-container>

    <ng-template #commTemplate let-fcuUnit="fcuUnit">
        <div class="fcu-comms-container">
            <app-dropdown-accordion
                class="comm-inner-accordion"
                header="system-settings.external-communication.title"
                [isPortsTable]="true"
                [isInitialOpen]="false">
                <app-ports-table
                    [ports]="fcuUnit.extComms.Ports"
                    [communicationProtocols]="communicationProtocols"
                    [commsList]="commsList"
                    [unitId]="fcuUnit.extComms.id">
                </app-ports-table>
            </app-dropdown-accordion>

            <app-dropdown-accordion
                class="comm-inner-accordion"
                *ngFor="let ceuUnit of fcuUnit.ceuUnits"
                [header]="getCEUHeader(ceuUnit)"
                [isPortsTable]="true"
                [isInitialOpen]="false"
                [showEditIcon]="true"
                (onDeleteCeuUnit)="handleDeleteCeuUnit(ceuUnit)"
                (onEditCeuUnit)="handleEditCeuUnit(ceuUnit)">
                <app-ports-table
                    [ports]="ceuUnit.Ports"
                    [communicationProtocols]="communicationProtocols"
                    [commsList]="commsList"
                    [isCeuUnit]="true"
                    [unitId]="ceuUnit.id">
                </app-ports-table>
            </app-dropdown-accordion>
            <div class="add-settings-row">
                <div class="add-button" [class.disabled]="isAddDisabled(fcuUnit.ceuUnits)" (click)="addUnit(fcuUnit)">
                    {{ 'ceu-unit.add' | translate }}
                </div>
                <div>
                    {{ 'ceu-unit.units-length' | translate: { num: fcuUnit.ceuUnits?.length || 0 } }}
                </div>
            </div>
        </div>
    </ng-template>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
